// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, boolean, number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindowsResult = objectOf({
  segments: arrayOf(
    objectOf({
      segment_id: string,
      analytics_tracking_enabled: boolean,
      tracking_windows: arrayOf(
        objectOf({
          start_at: number,
          end_at: anyOf(number, nullValidation),
        })
      ),
    })
  ),
  errors: arrayOf(string),
});
